/**
 * Slim, single-line compliance disclaimer for checkout / order / thank-you
 * pages where a full footer would distract from conversion.
 *
 * Required on every page that mentions a third-party platform name or sells
 * a promotion service, in order to comply with:
 *  - Google Ads "Misrepresentation" & "Dishonest behavior" policies
 *  - Each platform's third-party developer / marketing terms
 */
export const SlimComplianceFooter = ({ className = "" }: { className?: string }) => (
  <div
    className={`mx-auto max-w-3xl px-4 pb-8 pt-6 text-center text-[10px] leading-relaxed text-muted-foreground/80 sm:text-[11px] ${className}`}
    role="note"
    aria-label="Service disclaimer"
  >
    <span className="font-semibold text-muted-foreground">
      Independent marketing service.
    </span>{" "}
    TokDadddy is not affiliated with, endorsed by, or sponsored by TikTok,
    YouTube, Spotify, Instagram, Twitch, X (Twitter) or Facebook / Meta. All
    trademarks belong to their respective owners. We comply with each
    platform's terms of service and Google Ads advertising policies.
  </div>
);
